"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _styledSystem = require("styled-system");

var _iconUnicodes = _interopRequireDefault(require("./icon-unicodes"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _palette = _interopRequireDefault(require("../../style/palette"));

var _iconConfig = _interopRequireWildcard(require("./icon-config"));

var _browserTypeCheck = _interopRequireWildcard(require("../../utils/helpers/browser-type-check"));

var _color = _interopRequireDefault(require("../../style/utils/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const getBackgroundColor = (theme, bgTheme, disabled, isHover) => {
  if (bgTheme !== "none") {
    if (disabled) return theme.icon.disabled;
  }

  const palette = (0, _palette.default)({
    statusColor: theme.colors[bgTheme],
    businessColor: theme.colors.primary
  });
  const statuses = ["info", "error", "success", "warning"];

  if (statuses.includes(bgTheme)) {
    return isHover ? palette.statusColorShade(20) : theme.colors[bgTheme];
  }

  if (bgTheme === "business") {
    return isHover ? palette.businessColorShade(20) : theme.colors.primary;
  }

  return "transparent";
};

const getIconColor = (bgTheme, theme, iconColor, disabled, isHover) => {
  if (disabled) return theme.icon.disabled;

  if (bgTheme !== "none") {
    const whiteIconBackgrounds = ["error", "info", "business"];
    const darkIconBackgrounds = ["success", "warning"];
    if (whiteIconBackgrounds.includes(bgTheme)) return theme.colors.white;

    if (darkIconBackgrounds.includes(bgTheme)) {
      return isHover ? theme.icon.defaultHover : theme.icon.default;
    }
  }

  const palette = (0, _palette.default)({
    businessColor: theme.colors.primary
  });

  switch (iconColor) {
    case "on-dark-background":
      return theme.colors.white;

    case "on-light-background":
      return isHover ? theme.icon.onLightBackgroundHover : theme.icon.onLightBackground;

    case "business-color":
      return isHover ? palette.businessColorShade(20) : theme.colors.primary;

    default:
      return isHover ? theme.icon.defaultHover : theme.icon.default;
  }
};

function adjustIconBgSize(fontSize, bgSize) {
  var _replacements$fontSiz;

  const replacements = {
    medium: {
      small: "medium"
    },
    large: {
      small: "large",
      medium: "large"
    },
    "extra-large": {
      small: "extra-large",
      medium: "extra-large",
      large: "extra-large"
    }
  };
  const replacement = replacements === null || replacements === void 0 ? void 0 : (_replacements$fontSiz = replacements[fontSize]) === null || _replacements$fontSiz === void 0 ? void 0 : _replacements$fontSiz[bgSize];

  if (replacement) {
    return _iconConfig.default.backgroundSize[replacement];
  }

  return _iconConfig.default.backgroundSize[bgSize];
}

const StyledIcon = _styledComponents.default.span`
  ${({
  bgTheme,
  theme,
  color,
  bg,
  isInteractive,
  iconColor,
  bgSize,
  bgShape,
  type,
  fontSize,
  disabled
}) => {
  let finalColor;
  let finalHoverColor;
  let bgColor;
  let bgHoverColor;

  try {
    if (color) {
      const {
        color: renderedColor
      } = (0, _color.default)({
        color,
        theme
      });
      finalColor = renderedColor;
      finalHoverColor = (0, _polished.shade)(0.2, renderedColor);
    } else {
      finalColor = getIconColor(bgTheme, theme, iconColor, disabled, false);
      finalHoverColor = getIconColor(bgTheme, theme, iconColor, disabled, true);
    }

    if (bg) {
      const {
        backgroundColor
      } = (0, _color.default)({
        bg,
        theme
      });
      bgColor = backgroundColor;
      bgHoverColor = (0, _polished.shade)(0.2, backgroundColor);
    } else {
      bgColor = getBackgroundColor(theme, bgTheme, disabled, false);
      bgHoverColor = getBackgroundColor(theme, bgTheme, disabled, true);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return (0, _styledComponents.css)`
      display: inline-block;
      position: relative;
      color: ${finalColor};
      background-color: ${bgColor};
      vertical-align: middle;

      ${isInteractive && (0, _styledComponents.css)`
        &:hover {
          color: ${finalHoverColor};
          background-color: ${bgHoverColor};
        }
      `}

      ${bgTheme !== "none" && (0, _styledComponents.css)`
        align-items: center;
        display: inline-flex;
        justify-content: center;
        height: ${adjustIconBgSize(fontSize, bgSize)};
        width: ${adjustIconBgSize(fontSize, bgSize)};
        border-radius: ${_iconConfig.default.backgroundShape[bgShape]};
      `}

      &::before {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        font-family: CarbonIcons;
        content: "${_iconUnicodes.default[type]}";
        font-size: ${_iconConfig.default.iconSize[fontSize]};
        font-style: normal;
        font-weight: normal;
        line-height: ${_iconConfig.default.iconSize[fontSize]};
        vertical-align: middle;

        ${type === "services" && (0, _browserTypeCheck.default)(window) && (0, _styledComponents.css)`
          margin-top: ${fontSize === "small" ? "-7px" : "-8px"};
        `}

        ${type === "services" && (0, _browserTypeCheck.isSafari)(navigator) && !(0, _browserTypeCheck.default)(window) && (0, _styledComponents.css)`
          margin-top: -6px;
        `}
        
        display: block;
      }

      ${_styledSystem.margin}
    `;
}}
`;
StyledIcon.propTypes = {
  theme: _propTypes.default.object,
  type: _propTypes.default.string,
  isInteractive: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  bgSize: _propTypes.default.oneOf(["extra-small", "small", "medium", "large", "extra-large"]),
  bgShape: _propTypes.default.oneOf(_iconConfig.ICON_SHAPES),
  bgTheme: _propTypes.default.oneOf([..._iconConfig.ICON_COLORS, ..._iconConfig.ICON_BACKGROUNDS, ""]),
  fontSize: _propTypes.default.oneOf(["small", "medium", "large", "extra-large"]),
  iconColor: _propTypes.default.oneOf(_iconConfig.ICON_COLORS)
};
StyledIcon.defaultProps = {
  theme: _base.default
};
var _default = StyledIcon;
exports.default = _default;